<template>
  <div class="card min-width-60vw">
    <header class="bandeau-modal card-header">
    </header>
    <div class="pdl-20px pdr-20px">
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('gestionAffectation.popUpActionAffecter.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content pdl-0 pdr-0">
      <message-warning-tfs :tfsWithWarning="tfsWithWarning"
        :isAffectation="true" @close="closeMessage"></message-warning-tfs>
      <div class="columns is-multiline mgt-10px">
        <b-field :label="$t('gestionAffectation.popUpActionAffecter.actionAffichage')"
                 class="column is-12 mgb-0">
          <b-input v-model="actionAffichage"></b-input>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('addEditContratNature.actions.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="sauvegarder">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
    </div>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import searchTfsWithWarning from '@/services/affectation/searchTfsWithWarning';
import cloneDeep from 'lodash/cloneDeep';
import messageWarningTfs from './messageWarningTfs';

export default {
  name: 'p_actionAffecter',
  props: {
    actionAffichageDefaut: {
      required: false,
      type: String,
      default: null,
    },
    tfsSelectionnes: {
      type: Array,
      required: true,
    },
    anneeSemaine: {
      type: Number,
      required: true,
    },
  },
  components: {
    messageWarningTfs,
  },
  data() {
    return {
      actionAffichage: null,
      tfsWithWarning: [],
      openDetail: false,
    };
  },
  methods: {
    sauvegarder() {
      this.tfsSelectionnes.forEach((tfs) => {
        const findFace = this.tfsWithWarning.find((f) => f.codeFace === tfs.produitReference);
        if (findFace) tfs.selected = findFace.selected;
      });
      this.$emit('actionAffichage', this.actionAffichage, this.tfsSelectionnes.filter(el => el.selected));
    },
    closeMessage() {
      this.tfsWithWarning = [];
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.actionAffichageDefaut) {
        this.actionAffichage = cloneDeep(this.actionAffichageDefaut);
      }
      this.tfsWithWarning = await searchTfsWithWarning(this.tfsSelectionnes,
        this.anneeSemaine);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
